// Styles.js
import { styled } from "@mui/material/styles";
import { Box, Paper, TableCell } from "@mui/material";
import {
  TABLE_BODY_ROW_HEIGHT,
  TABLE_COMPACT_HEADER_HEIGHT,
  TABLE_COMPACT_HEADER_PADDING,
  TABLE_HEADER_FONT_SIZE,
} from "../Table/constants.js";

const jakartaRootSx = {
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  "& .MuiTypography-root, & .MuiButton-root, & .MuiInputBase-root, & .MuiInputLabel-root, & .MuiMenuItem-root, & .MuiTableCell-root, & .MuiChip-label, & .MuiFormLabel-root, & .MuiSelect-select":
    {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
    },
  "& .MuiTableBody-root .MuiTableRow-root.MuiTableRow-hover:hover": {
    backgroundColor: "#ECF1F7",
  },
};

/* =========================
   SETTINGS (ya existentes)
========================= */

export const PageContainer = styled(Box)(({ theme }) => ({
  ...jakartaRootSx,
  minHeight: "100%",
  padding: theme.spacing(4),
  background: "transparent",
  backgroundColor: "transparent",
}));

export const CardContainer = styled(Box)(({ theme }) => ({
  ...jakartaRootSx,
  marginTop: theme.spacing(4),
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing(3),
  padding: "30px",
  borderRadius: "20px",
  background: "transparent",
  boxShadow: "0px 24px 60px rgba(15, 23, 42, 0.06)",
}));

export const OptionCard = styled(Paper)(({ theme }) => ({
  ...jakartaRootSx,
  flex: "1 1 360px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: theme.spacing(4),
  borderRadius: theme.spacing(3),
  boxShadow: "0px 24px 60px rgba(15, 23, 42, 0.06)",
  cursor: "pointer",
  transition: "transform 0.15s ease, box-shadow 0.15s ease",
  backgroundColor: theme.palette.background.paper,
  height: "300px",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0px 30px 80px rgba(15, 23, 42, 0.10)",
  },
}));

export const OptionIconWrapper = styled(Box)(({ theme }) => ({
  width: 40,
  height: 40,
  borderRadius: theme.spacing(1.5),
  border: `1px solid ${theme.palette.divider}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const SettingsTitleWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.5),
}));

// Compatibilidad (ya existentes)
export const FiltersContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
}));

export const TableContainerStyled = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
}));

export const FooterContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  display: "flex",
  justifyContent: "flex-end",
}));

/* =========================
   PAYMENT RULES / TABLE BASE
   (AGREGADOS para evitar errores)
========================= */

export const PageRoot = styled(Box)(({ theme }) => ({
  ...jakartaRootSx,
  minHeight: "100%",
}));

export const TitleWrap = styled(Box)(({ theme }) => ({
  width: "calc(100vw - 280px)",
  maxWidth: 1600,
  padding: theme.spacing(3),
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(3),
  background: "transparent",
  backgroundColor: "transparent",
}));

export const MainCard__body = styled(Box)(({ theme }) => ({
  ...jakartaRootSx,
  display: "flex",
  flexDirection: "column",
  padding: "20px",
  width: "calc(100% - 10px)",
  maxWidth: "calc(100% - 10px)",
  minWidth: 0,
  borderRadius: "12px",
  background: "transparent",
  backgroundColor: "transparent",
  margin: "0 auto",
  boxSizing: "border-box",
  overflow: "visible",
  flexGrow: 0,
  flexShrink: 0,
  alignSelf: "flex-start",
}));

export const Card = styled(Paper)(({ theme }) => ({
  ...jakartaRootSx,
  borderRadius: 18,
  padding: "20px",
  boxShadow: theme.shadows[2],
  overflow: "hidden",
  border: "1px solid rgba(0,0,0,0.06)",
  background: "transparent",
  backgroundColor: "transparent",
}));

export const Toolbar = styled(Box)(({ theme }) => ({
  width: "100%",
  alignSelf: "stretch",
  padding: theme.spacing(0, 0, 3, 0),
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  marginTop: 0,
  flexWrap: "wrap",
  background: "transparent",
}));

export const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  fontSize: TABLE_HEADER_FONT_SIZE,
  fontWeight: 700,
  color: "rgba(0,0,0,0.70)",
  background: "#F9F9F9",
  borderBottom: 0,
  height: TABLE_COMPACT_HEADER_HEIGHT,
  padding: TABLE_COMPACT_HEADER_PADDING,
  lineHeight: "18px",
  whiteSpace: "nowrap",
}));

export const BodyCell = styled(TableCell)(({ theme }) => ({
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  color: "rgba(0,0,0,0.72)",
  height: TABLE_BODY_ROW_HEIGHT,
  borderBottom: "1px solid rgba(0,0,0,0.06)",
  padding: "0 0 0 16px",
}));

export const Footer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  background: "transparent",
}));

export const TotalText = styled(Box)(({ theme }) => ({
  fontSize: 12,
  color: "rgba(0,0,0,0.70)",
  color: "#6B7280",
  fontWeight: 400,
}));
